import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Switch,
  Alert,
} from "antd";

import { useDispatch } from "react-redux";
import { loginRequest } from "../../feature/auth/authSlice";
import { useSelector } from "react-redux";
import { appConfig } from "../../utils/appConfig";
import { useNavigate } from "react-router-dom";

import CopyRight from "../../components/CopyRight";
import { authSelector } from "../../feature/auth/authSelector";
import usePrevious from "../../hooks/usePrevious";

const { Title } = Typography;
const { Header, Footer, Content } = Layout;

const LoginContainer = () => {
  const [error, setError] = useState("");
  const { isLogin, userState, errorMessage } = useSelector(({ authState }) =>
    authSelector(authState)
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const prevIsLogin = usePrevious(isLogin);

  const onLogin = (values) => {
    const email = values.email.toLowerCase().replace(/\s/g, "");
    form.setFieldsValue({ email });
    dispatch(
      loginRequest({
        email: email,
        password: values.passwordNotComplete,
        remember: values.remember,
      })
    );
  };

  const onChange = () => {
    setError("");
  };

  useEffect(() => {
    if (userState.accessToken) {
      if (userState.role === "admin") {
        navigate("/admin/dashboard");
      } else {
        navigate("/partner/dashboard");
      }
    }
  }, [userState, navigate]);

  useEffect(() => {
    if (prevIsLogin && !isLogin) {
      if (errorMessage) {
        setError({ text: errorMessage.text, type: errorMessage.type });
      }
    }
  }, [isLogin]);

  return (
    <>
      <Layout className="layout-default layout-signin">
        <Header className="flex-center">
          <div className="header-col header-brand">
            <h5>Asinzen Referral Portal</h5>
          </div>
        </Header>
        <Content className="signin">
          <Row gutter={[24, 0]} justify="space-around">
            <Col xs={{ span: 24 }} lg={{ span: 6 }} md={{ span: 12 }}>
              <Title className="mb-15">Sign In</Title>
              <Title className="font-regular text-muted" level={5}>
                Enter your email and password to sign in
              </Title>
              {error && <Alert message={error.text} type={error.type} />}
              <Form
                form={form}
                layout="vertical"
                className="row-col"
                onFinish={onLogin}
              >
                <Form.Item
                  className="custom-form-item"
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please input your email!",
                    },
                  ]}
                  initialValue={localStorage.getItem(appConfig.USER_KEY)}
                >
                  <Input placeholder="Email" onChange={onChange} />
                </Form.Item>
                <Form.Item
                  className="custom-form-item"
                  label="Password"
                  name="passwordNotComplete"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                  ]}
                  initialValue={localStorage.getItem(appConfig.PASSWORD_KEY)}
                >
                  <Input.Password
                    placeholder="Password"
                    autoComplete="new-password"
                    onChange={onChange}
                  />
                </Form.Item>

                <div className="remember-and-forgot">
                  <div className="remember-container">
                    <Form.Item
                      name="remember"
                      className="aligin-center"
                      valuePropName="checked"
                      initialValue={true}
                    >
                      <Switch defaultChecked />
                    </Form.Item>
                    <span className="label-remember">Remember me</span>
                  </div>
                  <div
                    className="forgot-password"
                    onClick={() => navigate("/forgot-password")}
                  >
                    Forgot Password?
                  </div>
                </div>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                    loading={isLogin}
                  >
                    SIGN IN
                  </Button>
                </Form.Item>
                <p className="font-semibold text-muted">
                  Don't have an account?{" "}
                  <Link to="/sign-up" className="text-dark font-bold">
                    Sign Up
                  </Link>
                </p>
              </Form>
            </Col>
          </Row>
        </Content>
        <Footer>
          <CopyRight />
        </Footer>
      </Layout>
    </>
  );
};

export default LoginContainer;
